// RegistryChildren.jsx

import React from 'react';

// CSS
import './RegistryChildren.css';

// Components
import RegistryChildrenSuggested from 'admin/nodetypes/children/RegistryChildrenSuggested';

/**
 * RegistryChildren
 *
 * Related-types editor for a node type (`suggestedChildren` on the type doc).
 *
 * @param {string[]} suggestedChildren - Current related type keys.
 * @param {object[]} types - Available node type definitions.
 * @param {string} [hostTypeKey] - Type key of the type being edited.
 * @param {function} onSuggestedChange - Updates related type keys.
 * @param {boolean} [showTypeKeys=true] - Whether list rows show type keys.
 *
 * @returns {ReactNode} The rendered component.
 */
const RegistryChildren = ({
  suggestedChildren = [],
  types = [],
  hostTypeKey = '',
  onSuggestedChange,
  showTypeKeys = true,
}) => {

  // ----- RENDER ----- //

  return (
    <RegistryChildrenSuggested
      suggestedChildren={suggestedChildren}
      types={types}
      hostTypeKey={hostTypeKey}
      showTypeKeys={showTypeKeys}
      onChange={onSuggestedChange}
    />
  );
};


// Dev Tools
RegistryChildren.displayName = 'RegistryChildren';

export default RegistryChildren;
